import styled from 'styled-components';
import btnImg from './images/button.png';

export const BtnWrap = styled.div`
  width: 100%;
  padding: 21% 0 0;
`;

export const Btn = styled.button`
  display: block;
  width: 100%;
  max-width: 640px;
  border: 0;
  border-radius: 0;
  background: url(${btnImg}) center center no-repeat;
  background-size: cover;
  cursor: pointer;
  position: fixed;
  bottom: 0;
`;
